import BlockCard from './block-card'

export default BlockCard
